import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state) => state.orderCount || initialState;

export const selectOrderCountData = createSelector([selectDomain], (state) => state.data);
export const selectOrderCountLoading = createSelector([selectDomain], (state) => state.loading);
export const selectOrderCountError = createSelector([selectDomain], (state) => state.error);
